import { onChangeScrollValue } from './scroll';

const initialState = {
  readOnly: false,
  active: false,
  width: 0,
  height: 0,
  lineHeight: 120, // taille de la div subtitle-card-div
  nbVisibleLines: 0,
  subtitleNumber: 0,
  subtitleParameters: {},
  subtitles: [],
  filtered: false,
  subtitlesFiltered: [],
  commonErrors: [],
  currentSubtitleId: 0,
  scroll: {
    value: 0,
    hasChanged: false,
  },
  popup: {
    display: false,
    title: '',
    text: '',
    buttons: [],
    showIcon: false,
    icon: null,
    onCancel: null,
  },
  search: {
    showSearch: false,
    showReplace: false,
    searchText: '',
    totalWordsFounded: 0,
    currentPosition: null,
    showSelection: false,
    caseSensitive: false,
    wholeWord: false,
    wordsToSearch: [],
  },
};

let nbReducedCalled = 0;

const reducer = (state, action) => {
  // hack : le reducer est appelé deux fois en dev donc on va éviter d'exécuter le premier reducer
  // https://react.dev/reference/react/StrictMode#fixing-bugs-found-by-double-rendering-in-development
  if (process.env.NODE_ENV === 'development') {
    nbReducedCalled++;

    if (nbReducedCalled === 1) {
      return state;
    }

    nbReducedCalled = 0;
  }

  switch (action.type) {
    case 'onInit':
      return {
        ...state,
        ...action.value,
      };

    case 'onUpdateReadOnly':
      return {
        ...state,
        readOnly: action.value,
      };

    case 'onChangeParams':
      // 2 lignes par défaut, 35px est la hauteur du titre qui comporte des timecodes
      const nbLignes = action.value.numberOfLines - 2;
      const lineHeight = 120 + 35 * nbLignes;

      return {
        ...state,
        subtitleParameters: action.value,
        lineHeight,
      };

    case 'onUpdateSubtitles':   
    
      const { subtitles } = action.value;
      
      return {
        ...state,
        subtitles: subtitles.length ? [...subtitles] : [],
      };

    case 'onUpdateCurrentSubtitleId':      
      return {
        ...state,
        currentSubtitleId: action.value.id,
        active: action.value.active,
      };

    case 'onResize':
      const { width, height } = action.value;
      const nbVisibleLines = Math.floor(height / state.lineHeight);

      return {
        ...state,
        width,
        height,
        nbVisibleLines,
      };

    case 'onUpdateCurrentSubtitleIdAndScroll':      
      return {
        ...state,
        currentSubtitleId: action.value.id,
        active: action.value.active,
        scroll: {
          value: action.value.scrollValue,
          hasChanged: true,
        },
      };

    case 'onChangeScrollValue':
      return onChangeScrollValue(state, action.value);

    case 'onScrollHasChanged':
      return {
        ...state,
        scroll: {
          ...state.scroll,
          hasChanged: false,
        },
      };

    case 'setCommonErrors':
      return {
        ...state,
        commonErrors: action.value.commonErrors,
      };

    case 'onShowPopup':
      return {
        ...state,
        popup: {
          display: true,
          ...action.value,
        },
      };

    case 'onClosePopup':
      return {
        ...state,
        popup: {
          display: false,
          title: '',
          text: '',
          buttons: [],
          showIcon: false,
          icon: null,
          onCancel: null,
        },
      };
    
    case 'OnSearchOpen':
      return {
              ...state,
              search: {
                ...state.search,
                showSearch: true,
                showReplace: false,
              },
            };
    

    case 'OnSearchClose':     
        return {
          ...state,
          search: {
            showSearch: false,
            showReplace: false,
            searchText: '',
            totalWordsFounded: 0,
            currentPosition: null,
            showSelection: false,
            caseSensitive: false,
            wholeWord: false,
            wordsToSearch: [],
          },
        };

    case 'OnReplaceOpenOrClose':
      if (state.search.showReplace) {
        return {
          ...state,
          search: {
            ...state.search,
            showSearch: true,
            showReplace: false,
          },
        };
      }

      return {
        ...state,
        search: {
          ...state.search,
          showSearch: true,
          showReplace: true,
        },
      };

    case 'onSearchUpdate':
      const {
        showSelection,
        wordsToSearch,
        currentPosition,
      } = action.value;

      return {
        ...state,
        search: {
          ...state.search,
          wordsToSearch,
          currentPosition,
          totalWordsFounded: wordsToSearch.length,
          showSearch: true,
          showSelection,
        },
      };

    case 'onFilteredSubtitles':
      const { subtitlesFiltered } = action.value;

      return {
        ...state,
        filtered: true,
        subtitlesFiltered: [...subtitlesFiltered],
        scroll: {
          value: 0,
        },
      };

    case 'onSearchWordAndFilteredSubtitles':
      const {
        subtitlesFiltered: subFiltered,
        wordsToSearch: wSearch,
        text: textToSearch,
        caseSensitive: cs,
        wholeWord: ww,
      } = action.value;

      return {
        ...state,
        filtered: true,
        subtitlesFiltered: [...subFiltered],
        scroll: {
          value: 0,
        },
        search: {
          ...state.search,
          wordsToSearch: wSearch,
          searchText: textToSearch,
          caseSensitive: cs,
          wholeWord: ww,
        },
      };

    case 'onClearFilteredSubtitles':
      const currentIndex = state.subtitles.findIndex(
        (x) => x.id === state.currentSubtitleId
      );

      return {
        ...state,
        filtered: false,
        subtitlesFiltered: [],
        scroll: {
          value: currentIndex,
        },
        search: {
          ...state.search,
          searchText: '',
          caseSensitive: false,
          wholeWord: false,
          wordsToSearch: [],
        },
      };

    default:
      return state;
  }
};

export { reducer, initialState };
